/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-06-29 16:10:36
 * @LastEditors: linxi
 * @LastEditTime: 2021-09-17 14:04:14
 */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, TableColumnType } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { DateTimeFormatSimple } from "../../models/datetime";
import { getIncludeSystemAsync } from "./FactorySlice";

export const FactoryColumn = (
  onclick: (t: string, osId: any, name?: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  const dispatch = useDispatch<AppDispatch>();

  return [
    {
      title: '序号',
      key: 'no',
      width: '100px',
      align: 'center',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '卫健委(局)名称',
      dataIndex: 'osName',
      align: 'center',
      key: 'osName',
    },
    {
      title: '所在辖区',
      dataIndex: 'fullPath',
      align: 'center',
      key: 'fullPath',
    },
    {
      title: '最新上传时间',
      dataIndex: 'uploadTime',
      align: 'center',
      key: 'uploadTime',
      render: (_, r) => {
        return r.uploadTime === ''
          ? '-'
          : moment(r.uploadTime).format(DateTimeFormatSimple)
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '300px',
      render: function Element(_, t) {
        return (
          <div>
            <Button
              style={{ marginRight: '15px' }}
              type='primary'
              ghost
              size='small'
              onClick={(e: any) => {
                onclick('look', t.osId, t.name)
              }}
            >
              查看预警规则
            </Button>
            <Button
              style={{ color: '#fff ', background: '#1890ff', border: 'none' }}
              type='link'
              size='small'
              onClick={(e: any) => {
                dispatch(getIncludeSystemAsync(t.osId))
                  .then(unwrapResult)
                  .then((d: any) => {
                    if (
                      typeof d === 'string' &&
                      d.toLocaleLowerCase().startsWith('http')
                    ) {
                      window.open(d, '_blank')
                      // console.log(d);
                    }
                  })
              }}
            >
              进入系统
            </Button>
          </div>
        )
      },
    },
  ]
};
